export default function BestBtn(props){
    return(
        <button className="bestbtn">
            {props.btntext}
        </button>
    )
}